export const createPromptTemplate = templateAction => {
  return {
    createdAt: '',
    description: '',
    id: templateAction.label,
    header: templateAction.label,
    hubSpotRequired: false,
    intent: templateAction.intent || undefined,
    isFavorite: false,
    isFeatured: false,
    isNew: false,
    prompt: templateAction.promptSections,
    legacyPrompt: '',
    isMapped: true,
    mySqlId: 0
  };
};